import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { HomePage } from '@/teams/portfolio/pages/home-page/home-page.tsx'
import {
	DEFAULT_SECTION,
	SECTION_IDS,
} from '@/teams/portfolio/types/section-id.ts'

const searchSchema = z.object({
	section: z.enum(SECTION_IDS).catch(DEFAULT_SECTION),
})

export const Route = createFileRoute('/')({
	component: IndexRoute,
	validateSearch: searchSchema,
})

function IndexRoute() {
	const { section } = Route.useSearch()

	return <HomePage activeSection={section} />
}
